import React from 'react'
import LineItem from './LineItem'
import type { Line, Station } from '@pc/components/Works/Panel/type'

interface PropsType {
  lines: Line[]
  mappedStations: Record<string, Station[]>
  selectedStationIds: string[]
  changeStationIds: (stationIds: string[]) => void
}

const LineList = (props: PropsType) => {
  const { lines, mappedStations, selectedStationIds, changeStationIds } = props

  const Items = lines.map((line) => {
    const stations = mappedStations[line.id]
    return <LineItem key={line.id} line={line} stations={stations} selectedStationIds={selectedStationIds} changeStationIds={changeStationIds} />
  })

  return <>{Items}</>
}

export default LineList
